import { lazy, Suspense, useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { ModalRegistryItem, ModalValue } from './Modal';

interface ModalState {
  modal?: ModalValue | null;
}

interface RootState {
  modal?: ModalState | null;
}

const loadModal = () => import('./Modal');
const Modal = lazy(loadModal);

function ModalContainer({ modals }: { modals?: Record<string, ModalRegistryItem> }) {
  const modal = useSelector((state: RootState) => state.modal?.modal);

  useEffect(() => {
    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 200));
    const cancelIdle = window.cancelIdleCallback || clearTimeout;
    const handle = idle(() => {
      loadModal();
    });
    return () => cancelIdle(handle);
  }, []);

  if (!modal) {
    document.body.style.overflow = 'auto';
    return null;
  }
  return (
    <Suspense fallback={null}>
      <Modal modal={modal} modals={modals} />
    </Suspense>
  );
}

export default ModalContainer;
